import { createReducer } from './create';
import { parseDate } from '../../utils/get-date';

const ROWS_PER_PAGE = 20;

const initialState = {
    is_loading_products: false,
    unfiltered_products: [],
    products: [],
    cities: [],
    venues: [],
    has_teams: false,
    start_date: null,
    end_date: null,
    city: null,

    filter_start_date: null,
    filter_end_date: null,
    filter_city: null,

    view: 'list',

    current_page: 1,
    total_pages: 1,

    failed_to_load: false,
};

function filter_products(total_products, start_date, end_date, city) {
    let products = [];
    for (let i = 0, l = total_products.length, product, city_matched, startdate_matched, enddate_matched, team_matched; i <
    l; ++i) {
        product = total_products[i];
        city_matched = true;
        startdate_matched = true;
        enddate_matched = true;
        team_matched = true;

        // Check city or cities
        if (city !== null && product.venue.cities) {
            for (var x = 0, ll = product.venue.cities.length; x < ll; ++x) {
                if (product.venue.cities[x].slug == city) {
                    city_matched = true;
                    break;
                }

                city_matched = false;
            }
        }

        // Check for teams
        if (city !==
            null &&
            Object.keys(product.primary_category).length &&
            product.type ===
            20) {
            city_matched = true;
            if (product.primary_category.slug !== city) {
                team_matched = false;
            }
        }

        // Check startdate
        if (start_date !== null) {
            if (product.enddate !== null) {
                startdate_matched =
                    parseDate(product.enddate) >= parseDate(start_date);
            } else {
                startdate_matched =
                    parseDate(product.startdate) >= parseDate(start_date);
            }
        }

        // Check enddate
        if (end_date !== null) {
            enddate_matched =
                parseDate(product.startdate) <= parseDate(end_date);
        }

        // Return matched products
        if ((city_matched &&
            startdate_matched &&
            enddate_matched &&
            team_matched)) {
            products.push(product);
        }
    }

    let sorted = start_date != null || end_date != null || city != null;

    if (sorted) {
        products = products.sort(function productsSortFn(a, b) {
            if (parseDate(a.startdate) < parseDate(b.startdate)) {
                return -1;
            }
            if (parseDate(a.startdate) > parseDate(b.startdate)) {
                return 1;
            }
            return a.sales > b.sales
                ? -1
                : a.sales < b.sales
                    ? 1
                    : 0;
        });
    }

    return products;
}

export default createReducer(initialState, {
    ['ARCHIVE_PRODUCTS_LOAD_PRODUCTS']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_products: true,
        });
    },
    ['ARCHIVE_PRODUCTS_LOAD_PRODUCTS_FINISHED']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_products: false,
            unfiltered_products: payload.data.items,
            products: payload.data.items.slice(
                0,
                state.current_page * ROWS_PER_PAGE,
            ),
            cities: payload.data.cities,
            has_teams: payload.data.has_teams,
            total_pages: Math.ceil(payload.data.items.length / ROWS_PER_PAGE),
        });
    },
    ['ARCHIVE_PRODUCTS_LOAD_PRODUCTS_FAILED']: (state, payload) => {
        return Object.assign({}, state, {
            failed_to_load: true,
        });
    },
    ['ARCHIVE_PRODUCTS_LOAD_PRODUCTS_CLEAR_FAILED']: (state, payload) => {
        return Object.assign({}, state, {
            failed_to_load: false,
        });
    },
    ['ARCHIVE_PRODUCTS_FILTER_PRODUCTS']: (state, payload) => {
        const unfiltered_products = state.unfiltered_products;

        let filter_start_date = state.filter_start_date;
        if (payload.start_date !== undefined) {
            filter_start_date = payload.start_date;
        }

        let filter_end_date = state.filter_end_date;
        if (payload.end_date !== undefined) {
            filter_end_date = payload.end_date;
        }

        let filter_city = state.filter_city;
        if (payload.city !== undefined) {
            filter_city = payload.city;
        }

        let products = filter_products(
            unfiltered_products,
            filter_start_date,
            filter_end_date,
            filter_city,
        );

        const total_pages = Math.ceil(products.length / ROWS_PER_PAGE);

        products = products.slice(0, state.current_page * ROWS_PER_PAGE);

        return Object.assign({}, state, {
            products: products,
            start_date: filter_start_date,
            end_date: filter_end_date,
            city: filter_city,
            filter_start_date: filter_start_date,
            filter_end_date: filter_end_date,
            filter_city: filter_city,
            total_pages: total_pages,
        });
    },
    ['ARCHIVE_PRODUCTS_LOAD_MORE']: (state, payload) => {
        const current_page = state.current_page + 1;
        let products = [];
        let total_pages = 1;
        if (state.filter_start_date !=
            null ||
            state.filter_end_date ||
            state.filter_city) {
            products = filter_products(
                state.unfiltered_products,
                state.filter_start_date,
                state.filter_end_date,
                state.filter_city,
            );

            total_pages = Math.ceil(products.length / ROWS_PER_PAGE);

            products = products.slice(0, state.current_page * ROWS_PER_PAGE);
        } else {
            total_pages =
                Math.ceil(state.unfiltered_products.length / ROWS_PER_PAGE);
            products =
                state.unfiltered_products.slice(
                    0,
                    current_page * ROWS_PER_PAGE,
                );
        }

        return Object.assign({}, state, {
            products: products,
            total_pages: total_pages,
            current_page: current_page,
        });
    },
    ['ARCHIVE_PRODUCTS_SET_VIEW']: (state, payload) => {
        return Object.assign({}, state, {
            view: payload.view
        });
    }
});
